import { Autocomplete, FormControl, FormLabel, TextField } from '@mui/material';
import { useEffect } from 'react';

import { useDAL } from '@/contexts/useDAL';

import { EmptySelect } from '../selectors/emptySelect';

const title = 'Instance type';

export const InstanceTypeSelect = ({
  accountId,
  regionName,
  instanceType,
  onChange,
  subnetId,
}: {
  accountId?: string;
  regionName?: string;
  instanceType?: string;
  subnetId?: string;
  onChange: (instanceType?: string) => void;
}) => {
  if (!accountId || !regionName || !subnetId) {
    return <EmptySelect title={title} />;
  }

  return (
    <InnerInstanceTypeSelect
      subnetId={subnetId}
      accountId={accountId}
      regionName={regionName}
      instanceType={instanceType}
      onChange={onChange}
    />
  );
};

const InnerInstanceTypeSelect = ({
  subnetId,
  accountId,
  regionName,
  instanceType,
  onChange,
}: {
  accountId: string;
  regionName: string;
  subnetId: string;
  instanceType?: string;
  onChange: (instanceType?: string) => void;
}) => {
  const dal = useDAL();
  const { data: body, isLoading } = dal.restore.instanceTypes.useList(
    accountId,
    regionName,
    subnetId
  );

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (instanceType && !body?.instanceTypes?.includes(instanceType)) {
      onChange(undefined);
    }
  }, [body?.instanceTypes, isLoading, onChange, instanceType]);

  if (!body?.instanceTypes?.length) {
    return <EmptySelect title={title} />;
  }

  return (
    <FormControl size='small' className='flex-1'>
      <FormLabel>{title}</FormLabel>
      <Autocomplete
        data-testid='instanceTypeSelect'
        clearOnBlur
        size='small'
        value={instanceType || null}
        onChange={(_, newValue) => onChange(newValue || '')}
        renderOption={(props, option) => (
          <li
            {...props}
            key={option}
            data-testid={`instanceTypeOption-${body.instanceTypes?.indexOf(option)}`}
          >
            {option}
          </li>
        )}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              placeholder='Select'
              label=''
              slotProps={{ inputLabel: { shrink: true } }}
            />
          );
        }}
        options={body.instanceTypes}
      />
    </FormControl>
  );
};
